import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  ColoredText,
  CommonFlex,
  CommonGrid,
  CommonText,
  InputLabel,
} from '../../../styledComponents/common';
import StaticTaskLocationModal from '../../TaskLocations/StaticTaskLocationModal';
import {
  InfoContainer,
  InfoSectionContainer,
  OfficeDetailsSingleInfo,
} from '../officesStyles';
import ImageModal from './ImageModal';
import ItemsRelatedToCampsSectionDisplay from './ItemsRelatedToCampsSectionDisplay';

const ZoneDetails = ({ zone }) => {
  const { t } = useTranslation();

  const [seeLocationModalOpen, setSeeLocationModalOpen] = useState(false);
  const [selectedTaskLocation, setSelectedTaskLocation] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const handleShowLocation = location => {
    setSelectedTaskLocation(location);

    setTimeout(() => {
      setSeeLocationModalOpen(true);
    }, 300);
  };

  const handleImageClick = () => {
    setIsImageModalOpen(true);
  };

  const handleCloseImageModal = () => {
    setIsImageModalOpen(false);
  };

  return (
    <>
      <StaticTaskLocationModal
        isOpen={seeLocationModalOpen}
        toggle={() => {
          setSeeLocationModalOpen(false);
          setSelectedTaskLocation(null);
        }}
        taskLocation={selectedTaskLocation}
      />
      <InfoSectionContainer>
        <InfoContainer>
          <OfficeDetailsSingleInfo>
            <InputLabel>{t('camp_area')}:</InputLabel>
            <CommonText>{zone.area}</CommonText>
          </OfficeDetailsSingleInfo>
        </InfoContainer>
        <InfoContainer>
          {zone.camp_numbers?.map(camp => (
            <OfficeDetailsSingleInfo key={camp.id}>
              <InputLabel>{t('camp_number')}:</InputLabel>
              <CommonText>{camp.number}</CommonText>
            </OfficeDetailsSingleInfo>
          ))}
        </InfoContainer>
        {zone?.public_zone_name !== 'Muzdalifah' && (
          <InfoContainer>
            <OfficeDetailsSingleInfo>
              <InputLabel>{t('number_of_main_gate')}:</InputLabel>
              <CommonText>{zone.main_gate_number}</CommonText>
            </OfficeDetailsSingleInfo>
            <OfficeDetailsSingleInfo>
              <InputLabel>{t('number_of_kitchen')}:</InputLabel>
              <CommonText>{zone.kitchen_number}</CommonText>
            </OfficeDetailsSingleInfo>
            <OfficeDetailsSingleInfo>
              <InputLabel>{t('number_of_bathroom')}:</InputLabel>
              <CommonText>{zone.bathroom_number}</CommonText>
            </OfficeDetailsSingleInfo>
          </InfoContainer>
        )}
      </InfoSectionContainer>
      <InfoSectionContainer>
        {' '}
        <CommonText Text name title fontSize="16px">
          {t('location')}
        </CommonText>
        <InfoContainer>
          <OfficeDetailsSingleInfo
            style={{ marginBottom: `30px`, position: 'relative' }}
          >
            <InputLabel>{t('location_address')}:</InputLabel>
            <CommonText name>{zone?.address}</CommonText>{' '}
            {zone?.address && zone?.latitude && zone?.longitude && (
              <ColoredText
                type="warning"
                hover
                onClick={() =>
                  handleShowLocation({
                    id: zone.id,
                    latitude: parseFloat(zone.latitude, 10),
                    longitude: parseFloat(zone.longitude, 10),
                    name: zone.address,
                    radius: zone.radius,
                  })
                }
                fontSize="14px"
                style={{
                  cursor: 'pointer',
                  position: 'absolute',
                  left: 0,
                  top: '20px',
                }}
              >
                {t('see_location')}
              </ColoredText>
            )}
          </OfficeDetailsSingleInfo>
        </InfoContainer>
      </InfoSectionContainer>

      {zone.sketch_image && (
        <InfoSectionContainer>
          <CommonText Text name title fontSize="16px">
            {t('sketch_image')}:
          </CommonText>
          <CommonGrid
            gap="20px"
            style={{
              gridTemplateColumns: 'repeat(auto-fill, minmax(600px, 1fr))',
            }}
          >
            <iframe
              src={zone.sketch_image}
              title="PDF Preview"
              style={{ width: '100%', height: '550px', marginTop: '5px' }}
            />
          </CommonGrid>
          <ImageModal
            isOpen={isImageModalOpen}
            onClose={handleCloseImageModal}
            imageSrc={zone.sketch_image}
            altText="Sketch"
          />
        </InfoSectionContainer>
      )}
      <InfoSectionContainer>
        {(zone.itemSummary?.length > 0 &&
          zone?.public_zone_name !== 'Muzdalifah') && (
            <ItemsRelatedToCampsSectionDisplay items={zone.itemSummary} />
          )}
      </InfoSectionContainer>
      <InfoSectionContainer>
        <div
          style={{
            width: '100%',
          }}
        >
          <CommonText name title fontSize="16px">
            {t('permits_and_contracts')}:
          </CommonText>
          <CommonGrid
            gap="20px"
            style={{
              gridTemplateColumns: 'repeat(auto-fill, minmax(600px, 1fr))',
            }}
          >
            {zone.permits_and_contracts?.map(contract => (
              <CommonFlex
                style={{
                  marginTop: '10px',
                  padding: '10px',
                  backgroundColor: '#E0BFB81F',
                  borderRadius: '6px',
                }}
                direction="column"
                key={contract.id}
              >
                {contract.name && (
                  <CommonText
                    fontSize="14px"
                    fontWeight="bold"
                    active
                    onClick={() => window.open(contract.pdf_file, '_blank')}
                  >
                    {contract.name}
                  </CommonText>
                )}
                <iframe
                  src={contract.pdf_file}
                  title={`PDF Preview ${contract.id}`}
                  style={{ width: '100%', height: '550px', marginTop: '5px' }}
                />
                <div
                  style={{
                    backgroundColor: '#E0BFB899',
                    padding: '10px',
                    borderRadius: '6px',
                    width: '100%',
                  }}
                >
                  {contract.description}
                </div>
              </CommonFlex>
            ))}
          </CommonGrid>
        </div>
      </InfoSectionContainer>
    </>
  );
};

export default ZoneDetails;
